const HEADERS = ["Row #", "Product Code", "Item Name", "Width", "Height", "Depth", "Length", "Quantity", "Material", "Finish", "Notes"];

const humanize = (value) => String(value || "").replace(/_/g, " ").replace(/\b\w/g, letter => letter.toUpperCase());

export const supplierRows = (sections, selectedIds) => {
  const selected = selectedIds instanceof Set ? selectedIds : new Set(selectedIds || []);
  return Object.values(sections || {}).flatMap(sectionRows => sectionRows.filter(row => selected.has(row.row_id)).map((row, index) => ({
    rowNumber: index + 1,
    itemCode: row.item_code || "",
    itemName: row.description || row.item_name || row.item_type || "",
    width: row.width || "",
    height: row.height || "",
    depth: row.depth || "",
    length: row.length || "",
    quantity: row.quantity ?? "",
    material: humanize(row.material),
    finish: String(row.finish_required || row.finish || "").toLowerCase() === "none" ? "" : humanize(row.finish_required || row.finish),
    notes: row.notes || "",
  })));
};

const csvValue = value => {
  let text = String(value ?? "");
  if (/^[=+\-@]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
};

export const exportSupplierCsv = (rows, sheetNumber) => {
  const body = rows.map(row => [row.rowNumber, row.itemCode, row.itemName, row.width, row.height, row.depth, row.length, row.quantity, row.material, row.finish, row.notes].map(csvValue).join(","));
  const csv = `\ufeff${HEADERS.map(csvValue).join(",")}\r\n${body.join("\r\n")}`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `Supplier_Manifest_${String(sheetNumber || "Production").replace(/[^A-Za-z0-9_-]/g, "_")}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export { HEADERS as SUPPLIER_EXPORT_HEADERS };